module.exports = __webpack_public_path__ + "assets/img/ticket_making.a4ec45f6.png";